// src/services/upcomingSessionAPI.js
import { API_BASE_URL } from '../../config/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  console.log('🔑 Token from localStorage:', token ? 'Present' : 'Missing');
  
  if (!token) {
    console.error('❌ No JWT token found in localStorage');
  }
  
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(errorData.error || errorData.message || 'Request failed');
  }
  const data = await response.json();
  console.log('✅ API Response:', data);
  return data;
};

// GET - Get all upcoming sessions
export const getUpcomingSessionsAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/api/upcoming-sessions${queryString ? `?${queryString}` : ''}`;
    
    const res = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get upcoming sessions error:', error);
    throw error;
  }
};

// GET - Get session by ID
export const getSessionByIdAPI = async (sessionId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/upcoming-sessions/${sessionId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get session by ID error:', error);
    throw error;
  }
};

// POST - Create new session
export const createSessionAPI = async (sessionData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/upcoming-sessions`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(sessionData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Create session error:', error);
    throw error;
  }
};

// PUT - Update session
export const updateSessionAPI = async (sessionId, updateData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/upcoming-sessions/${sessionId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(updateData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Update session error:', error);
    throw error;
  }
};

// DELETE - Delete session
export const deleteSessionAPI = async (sessionId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/upcoming-sessions/${sessionId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Delete session error:', error);
    throw error;
  }
};

// Helper function to handle API errors
export const handleAPIError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.message || 'An unexpected error occurred',
    status: 0,
  };
};
